import imgproxy from "@evercam/shared/plugins/imgproxy"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin(imgproxy)
